<template>
    <div id="role-integration-curp">
        <!-- inicio de sesión cuando es mismo rol  -->
        <vs-popup class="header-primary" :active.sync="showCurpMatchPopup" title="Tu cuenta ya existe">
            <div v-if="!sameEmail" class="p-6">
                <p class="mb-4 black">
                    Encontramos una cuenta de <b>{{ currentRole }}</b> asociada a este <b>RFC</b> con el correo <b>{{
                        userEmail }}</b>.

                    Para continuar, inicia sesión con el correo <b>{{ userEmail }}</b>.
                    <br> Si ya no tienes acceso, contáctanos en soporte y te ayudaremos a recuperar tu cuenta.
                </p>

                <vs-button class="mb-4" @click="showCurpMatchPopup = false, goToLogin()">Ir a iniciar
                    sesión</vs-button>
                <p class="black">¿Olvidaste tu contraseña? <span
                        @click="showCurpMatchPopup = false, gotoPasswordReset()" class="clickable-img"><b><u>Da clic
                                aquí</u></b></span></p>
            </div>
            <div v-else class="p-6">
                <p class="mb-4 black">Ya existe tu cuenta con este correo. Solo debes iniciar sesión.</p>

                <vs-button class="mb-4" @click="showCurpMatchPopup = false, goToLogin()">Ir a iniciar
                    sesión</vs-button>
                <p class="black">¿Olvidaste tu contraseña? <span
                        @click="showCurpMatchPopup = false, gotoPasswordReset()" class="clickable-img"><b><u>Da clic
                                aquí</u></b></span></p>
            </div>
        </vs-popup>

        <!-- Es mismo curp, diferente rol, enviar a soporte  -->
        <vs-popup class="header-primary" :active.sync="showCurpRoleIntegrationPopup" title="Ya eres usuario en RedGirasol">
            <div class="p-6">
                <p class="mb-base black">
                    Encontramos una cuenta de <b>{{ roleToShow }}</b> asociada a este CURP o RFC con el correo <b>{{ userEmail }}</b>.
                    Para continuar con la integración de tu cuenta de <b>{{ currentRole }}</b>, por favor contáctanos en soporte y te ayudaremos a integrarla.                
                </p>

                <vs-button @click="showCurpRoleIntegrationPopup = false">Continuar</vs-button>
            </div>
        </vs-popup>

        <!-- es un OS que quiere ser nueva cuenta -->
        <vs-popup class="header-primary" :active.sync="showOsRoleIntegrationPopup" title="Tu cuenta ya existe">
            <div class="p-6">
                <p class="mb-base black">
                    Ya existe un registro a tu nombre en RedGirasol. Te enviamos un código para confirmar que eres tú a <b>{{ userEmail }}</b>.
                </p>


                <vs-button @click="requestVerificationCode(true)">Continuar</vs-button>
                <vs-popup class="header-primary" :active.sync="showEmailVerificationCodePopup"
                    title="Confirma que eres tú">
                    <div class="p-6">
                        <p class="mb-4 black">
                            Ingresa los 6 dígitos del código que enviamos por correo a <b>{{ userEmail }}</b>.
                        </p>
                        <vs-input type="text" name="email-code" class="mb-4" maxlength="6" v-model="codeEmail"
                            @input="onCodeInput" :danger="codeEmail.length > 0 && codeEmail.length !== 6"
                            danger-text="Debe tener exactamente 6 números"></vs-input>
                        <p class="black mb-base">¿No lo recibiste?
                            <span v-if="resendTimer > 0">
                                Reenviar en
                                <b>{{ resendTimer }}s</b>
                            </span>
                            <span @click.stop="requestVerificationCode()" class="clickable-img" v-else>
                                <u>Reenviar</u>
                            </span>
                        </p>
                        <vs-button :disabled="!isValidCode()" @click.stop="requestRoleIntegration()"
                            color="primary">Continuar</vs-button>
                    </div>
                </vs-popup>

            </div>
        </vs-popup>
    </div>

</template>

<script>
export default {
    name: "RoleIntegrationByRfc",
    data: () => ({
        showCurpMatchPopup: false,
        showCurpRoleIntegrationPopup: false,
        showEmailVerificationCodePopup: false,
        showOsRoleIntegrationPopup: false,
        userEmail: "",
        sameEmail: false,
        roleToShow: "",
        userEmailFull: null,
        codeEmail: "",
        resendTimer: 45,
        resendEnabled: false,
        timer: null,
        modelId: null,
        flowName: ""
    }),
    props: {
        matchedData: Object,
        currentRole: String,
        modelToUpdate: [String, Number],
        isBusiness: Boolean,
        isNewUser: Boolean,
        isRepLegal: Boolean,
    },
    mounted() {
        this.checkFlow();
        this.setUpTimerConfig();
    },
    methods: {
        checkFlow() {
            this.modelId = this.modelToUpdate;

            // Dependiendo de la sugerencia, se debe continuar con el flujo de integración al rol o redirigir a login
            const actions = this.matchedData.suggested_actions;
            for (let index = 0; index < actions.length; index++) {
                let action = actions[index];
                if (this.isNewUser && action == "recover_user_business_account") {
                    // Se encontró un usuario con el mismo curp pero hay que verificar el role
                    const matchRole = this.checkRoleMatch(this.matchedData.matches.user_business);
    
                    // Sí el rol coincide, se invita a hacer login
                    if (matchRole) {
                        this.showCurpMatchPopup = true;
                        this.roleToShow = this.currentRole;
                        break;
                    } else {
                        // Sí es un Representante legal se ignora
                        if(this.isRepLegal) {
                            continue;
                        }

                        // Sí el rol no coincide, no se permite avanzar y se invita a contactar a soporte para integrar las cuentas
                        this.roleToShow = this.matchedData.matches.user_business.roles[0];
                        this.showCurpRoleIntegrationPopup = true;
                        break;
                    }
                } else if( action == "review_guarantee_business_profile") {
                    this.roleToShow = "Obligado solidario Persona Moral";
                    this.showOsRoleIntegrationPopup = true;
                    this.userEmail = this.matchedData.matches.guarantee_business.email_masked;
                    this.userEmailFull = this.matchedData.matches.guarantee_business.email;
                    // this.modelId = this.UserId;
                    this.flowName = this.isBusiness ? 'os_pm_to_user_pm_rfc' : "os_pm_to_user_pf_rfc";
                    break;
                } else if (action == "review_stakeholder_business_profile") { // Se encontró un stakeholder PM con la misma información, se asume que quiere ser usuario personal
                    this.roleToShow = "Accionista";
                    this.showOsRoleIntegrationPopup = true;
                    this.userEmail = this.matchedData.matches.stakeholder_business.email_masked;
                    this.userEmailFull = this.matchedData.matches.stakeholder_business.email;
                    // this.modelId = this.UserId;
                    this.flowName = this.isBusiness ? 'stakeholder_pm_to_user_pm_rfc' : "stakeholder_pm_to_user_pf_rfc";
                    break;
                }
            }

            // Sí es un OS, entonces el flujo se renombra 
            if(this.currentRole == "Obligado solidario") {
                this.flowName = this.isBusiness ? 'os_pm_to_profile' : "os_to_profile";
            }

            // Sí es un Accionista, entonces el flujo se renombra
            if(this.currentRole == "Accionista") {
                this.flowName = this.isBusiness ? 'stakeholder_pm_to_profile' : "stakeholder_to_profile";
            }
        },
        checkRoleMatch(userData) {
            if (userData == null) return;
            // Sí es solicitante el rol que ya tiene, se sugiere iniciar sesión
            const matchRole = userData.roles.includes(this.currentRole);
            this.matchedRole = userData.roles[0];
            this.userEmail = userData.email_masked;
            this.userEmailFull = userData.email;

            this.sameEmail = this.user.email === userData.email;

            // Sí la cuenta coincide con el rol, se invita a hacer login
            return matchRole;
        },
        async requestVerificationCode(isResending = false) {
            try {
                this.showLoading(true, isResending ? "Reenviando código..." : "Enviando código...");
                const res = await this.publicApiPost("/api/auth/user/role-integration/verification-code", {
                    email: this.userEmailFull
                });

                if (res.data.is_valid) {
                    if (isResending) {
                        this.showEmailVerificationCodePopup = true;
                    }
                    this.setUpTimerConfig();
                } else {
                    this.errorNotif("Error en la operación.")
                }

            } catch (error) {
                this.showLoading(false);
                this.showError(error);
            } finally {
                this.showLoading(false);
            }
        },
        async requestRoleIntegration() {
            try {
                this.showLoading(true, "Integrando tu cuenta...");
                const res = await this.publicApiPost("/api/auth/user/role-integration/integrate-profile", {
                    email: this.userEmailFull,
                    code: this.codeEmail,
                    flow_name: this.flowName,
                    new_pp_id: this.matchedData.business_profile_id,
                    model_id: this.modelId // El modelo del que se va a actualizar
                });

                this.showLoading(false);

                if(res.data.success) {
                    this.saveSuccessNotif();
                    // window.location.reload();
                } else {
                    this.missingFieldsNotif(null, res.data.error)
                }

            } catch (error) {
                this.showLoading(false);
            } finally {
                this.showLoading(false);
            }
        },
        
        async goToLogin() {
            await this.$router.replace({ name: 'login' });
        },
        async goToLogin() {
            this.logout();
            await this.$router.replace({ name: 'login' });
        },
        async gotoPasswordReset() {
            await this.$router.push({ name: 'recuperarPassword' });
        },
        async logout() {
            // elimina el emailRemember del localstorage para evitar conflictos con el flujo de recuperación de contraseña
            localStorage.removeItem('emailRemember');
            this.showFullPageLoader();
            await this.executeAppLogout();
        },
                onCodeInput() {
            // deja solo números
            this.codeEmail = (this.codeEmail || '').replace(/\D/g, '').slice(0, 6)
        },
        isValidCode() {
            return /^\d{6}$/.test(this.codeEmail)
        },
        setUpTimerConfig() {
            window.clearInterval(this.timer);
            this.resendEnabled = false;
            this.resendTimer = 45;

            this.$nextTick(() => {
                this.initNipCounter();
            });
        },
        initNipCounter() {
            window.clearInterval(this.timer);

            this.timer = setInterval(() => {
                if (this.resendTimer > 0) {
                    this.resendTimer--;
                }

                if (this.resendTimer <= 0) {
                    window.clearInterval(this.timer);
                    this.timer = null;
                    this.resendEnabled = true;
                }
            }, 1000);
        },
    }
}
</script>